import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';

/**
 * Budgira Frontend - Entry Point
 * 
 * Main entry point for the Budgira React application.
 * Uses React 18 with StrictMode for development checks.
 * 
 * @validates Requirements 18.2 - React 18 with TypeScript and Vite
 */

// Force light mode on initial load - dark mode will be applied later if user is authenticated
// This prevents flash of dark mode from persisted localStorage before auth check
document.documentElement.classList.remove('dark');

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element. Please ensure your HTML has a div with id="root".');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
